import {Table} from "antd";
import React, {FC} from "react";
import './tableComponent.scss';

interface TableComponentProps{
    dataSource: any;
    columns: any;
    pagination?:any;
    handleRowClick?: Function;
    fetchList?:Function;
    setCurrentPage?:Function;
    loading?:boolean;
    setPageSize?:Function;
}

const TableComponent:FC<TableComponentProps> = (props) => {

    const {dataSource, columns, pagination, handleRowClick, fetchList, setCurrentPage, setPageSize, loading} = props;

    const handlePageChange = (page:number, pageSize: any) => {
        if(setCurrentPage) setCurrentPage(page);
        if(setPageSize) setPageSize(pageSize);
        if(fetchList) fetchList(page);
    }

    return(
        <div className='table-list'>
            <Table dataSource={dataSource}
                   columns={columns}
                   loading={loading}
                   pagination={{
                       onChange: handlePageChange,
                       current:pagination?.currentPage,
                       total:pagination?.totalCount || 0,
                       size:"small",
                       hideOnSinglePage:true,
                       pageSize: pagination?.pageSize ? pagination.pageSize : 15,
                   }}
                   onRow={(record) => {
                       return {
                           onClick: event => {
                               if(handleRowClick) handleRowClick(event,record)
                           },
                       };
                   }}
            />
        </div>
    )
}

export default TableComponent;
